import {
  AnySensorFusionLookupDto,
  isSensorFusionStageDefinitionLookupDto,
  isSensorFusionStageInstanceLookupDto,
  isSensorFusionSubstageDefinitionLookupDto,
  isSensorFusionSubstageInstanceLookupDto,
  isSensorFusionUnifiedProjectLookupDto,
  isSensorFusionUnifiedTaskLookupDto,
} from '@scale/sensor-fusion-shared';
import type { Extras } from 'corp/components/Lookup/LookupTypes';
import { Redirect } from 'react-router';

import {
  SensorFusionLookupProvider,
  SensorFusionStageDefinitionLookupView,
  SensorFusionStageInstanceLookupView,
  SensorFusionSubstageDefinitionLookupView,
  SensorFusionSubstageInstanceLookupView,
  SensorFusionUnifiedProjectLookupView,
  SensorFusionUnifiedTaskLookupView,
} from 'react-scale/dashboard.scale.com/components/SensorFusionLookup';

interface Props {
  object: AnySensorFusionLookupDto;
  config: { REMOTASKS_FRONTEND_URL?: string; SCALE_DASHBOARD_FRONTEND_URL?: string };
  extras: Extras;
}

const SensorFusionLookupObject = ({ object, config, extras }: Props) => {
  const isCorp = window.location.search.includes('force_corp=true');

  return (
    <SensorFusionLookupProvider
      initialState={{
        remotasksFrontendUrl: config.REMOTASKS_FRONTEND_URL,
        scaleDashboardFrontendUrl: config.SCALE_DASHBOARD_FRONTEND_URL,
      }}
    >
      {isSensorFusionStageDefinitionLookupDto(object) ? (
        <SensorFusionStageDefinitionLookupView stageDefinition={object} />
      ) : isSensorFusionStageInstanceLookupDto(object) ? (
        isCorp ? (
          <SensorFusionStageInstanceLookupView stageInstance={object} extras={extras} />
        ) : (
          <Redirect to={`/multistage/stage-instance/${object._id}`} />
        )
      ) : isSensorFusionSubstageDefinitionLookupDto(object) ? (
        <SensorFusionSubstageDefinitionLookupView substageDefinition={object} />
      ) : isSensorFusionSubstageInstanceLookupDto(object) ? (
        <SensorFusionSubstageInstanceLookupView substageInstance={object} extras={extras} />
      ) : isSensorFusionUnifiedProjectLookupDto(object) ? (
        isCorp ? (
          <SensorFusionUnifiedProjectLookupView project={object} />
        ) : (
          <Redirect to={`/multistage/project/${object._id}`} />
        )
      ) : isSensorFusionUnifiedTaskLookupDto(object) ? (
        isCorp ? (
          <SensorFusionUnifiedTaskLookupView task={object} extras={extras} />
        ) : (
          <Redirect to={`/multistage/task/${object._id}`} />
        )
      ) : (
        (() => {
          throw new Error('SensorFusionLookupObject rendered with an unknown object');
        })()
      )}
    </SensorFusionLookupProvider>
  );
};

export const redirectToMultistage = (objectType: string) => {
  const origin = window.location.origin.includes('localhost')
    ? 'http://localhost:3103'
    : window.location.origin;

  window.location.replace(
    `${origin}/sensorfusion/ops-hub/${objectType}/${window.location.pathname.split('/')[4]}`,
  );
};

export default SensorFusionLookupObject;
